import { bool, oneOf, string } from 'prop-types'
import { useEffect } from 'react'

import { PAGE_TYPE_SEARCH_RESULTS, PAGE_TYPES } from 'shared/consts/page'
import { shouldRenderNewLayout } from 'shared/experiments/components/NewSerp/helpers'
import ProductFilterVariant from 'shared/experiments/components/NewSerp/ProductFilterVariant'
import ProductFilterVariantV1 from 'shared/experiments/components/NewSerp/ProductFilterVariant/ProductFilterVariantV1'
import {
  EXPERIMENT_VARIATION,
  NEW_SEARCH_PAGE_LAYOUT_V3,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperiment,
} from 'shared/experiments/utils/experiments'
import ProductFilter from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter'
import ProductFilterV1 from 'views/components/organisms/AlgoliaInstantSearch/ProductFilterV1/ProductFilterV1'
import SearchContainerContent from 'views/components/organisms/AlgoliaInstantSearch/SearchContainerContent'
import CmsLayout from 'views/components/templates/CmsLayout'
import {
  downNavTreeType,
  navItemType,
  upNavTreeType,
} from 'views/utils/propTypes'
import {
  usePageProperties,
  usePublicConfig,
} from 'views/utils/shopAndRuntimeConfigUtils'

import './SearchResults.scss'

const SearchResults = ({
  hidden,
  indexName,
  infoText,
  logoPath,
  noveltiesIndexName,
  pageType,
  query,
  secondaryNavTitle,
  secondaryNavTree,
  title,
  topNav,
  upNavTree,
  isFilterApplied,
}) => {
  const { deviceClass } = usePublicConfig()
  const { experiments } = usePageProperties()

  const { isEnabled, variant } = getExperiment(
    NEW_SEARCH_PAGE_LAYOUT_V3,
    experiments
  )

  const isNewSearchEnabled =
    [EXPERIMENT_VARIATION.V1].includes(variant) &&
    pageType === PAGE_TYPE_SEARCH_RESULTS

  useEffect(() => {
    if (isEnabled) {
      activateExperiment(NEW_SEARCH_PAGE_LAYOUT_V3)
    }
  }, [isEnabled])

  return (
    <div className="o-SearchResults" aria-hidden={hidden ? 'true' : null}>
      {shouldRenderNewLayout({ deviceClass, pageType }) ? (
        <CmsLayout
          className="SearchResults--sidebarFlyout"
          title={title}
          logoPath={logoPath}
          topNav={topNav}
          upNavTree={upNavTree}
          secondaryNavTitle={secondaryNavTitle}
          secondaryNavTree={secondaryNavTree}
          infoText={infoText}
          pageType={pageType}
          slot={
            isNewSearchEnabled ? (
              <ProductFilterVariantV1 indexName={indexName} />
            ) : (
              <ProductFilterVariant indexName={indexName} />
            )
          }
        >
          <SearchContainerContent
            indexName={indexName}
            noveltiesIndexName={noveltiesIndexName}
            pageType={pageType}
            title={title}
            query={query}
            isFilterApplied={isFilterApplied}
          />
        </CmsLayout>
      ) : (
        <CmsLayout
          title={title}
          logoPath={logoPath}
          topNav={topNav}
          upNavTree={upNavTree}
          secondaryNavTitle={secondaryNavTitle}
          secondaryNavTree={secondaryNavTree}
          infoText={infoText}
          pageType={pageType}
          displayDirectionColumn={isNewSearchEnabled}
          slot={
            isNewSearchEnabled ? (
              <ProductFilterV1 indexName={indexName} pageType={pageType} />
            ) : (
              <ProductFilter indexName={indexName} pageType={pageType} />
            )
          }
        >
          <SearchContainerContent
            indexName={indexName}
            noveltiesIndexName={noveltiesIndexName}
            pageType={pageType}
            title={title}
            query={query}
            isFilterApplied={isFilterApplied}
          />
        </CmsLayout>
      )}
    </div>
  )
}

SearchResults.propTypes = {
  query: string.isRequired,
  pageType: oneOf(PAGE_TYPES),
  title: string,
  logoPath: string,
  topNav: navItemType,
  upNavTree: upNavTreeType,
  secondaryNavTitle: string,
  secondaryNavTree: downNavTreeType,
  infoText: string,
  indexName: string.isRequired,
  hidden: bool.isRequired,
  noveltiesIndexName: string,
  isFilterApplied: bool,
}

SearchResults.defaultProps = {
  pageType: null,
  title: null,
  logoPath: null,
  topNav: null,
  upNavTree: [],
  secondaryNavTitle: null,
  secondaryNavTree: [],
  infoText: null,
  noveltiesIndexName: null,
  isFilterApplied: false,
}

export default SearchResults
